module.exports = __webpack_public_path__ + "static/img/border.011de14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/border.png
// module id = cIqf
// module chunks = 1